import { ThemedText } from "@/components/themed-text";
import { useAuth } from "@/contexts/auth-context";
import Ionicons from "@react-native-vector-icons/ionicons";
import React from "react";
import { StyleSheet, View } from "react-native";
import { BackToHomeButton } from "./BackToHomeButton";

export const BookingNotFound = () => {
  const { theme } = useAuth();
  return (
    <View style={[styles.container, { backgroundColor: theme.background }]}>
      <Ionicons name="location-outline" size={34} color={theme.text} />
      <ThemedText style={styles.title} type="title">
        Tracking Not Available
      </ThemedText>
      <ThemedText style={styles.message} type="small">
        Live tracking is only available when a driver has been assigned and the
        booking is in progress.
      </ThemedText>
      <BackToHomeButton />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    padding: 20,
  },
  icon: {
    fontSize: 64,
    marginBottom: 20,
  },
  title: {
    fontSize: 24,
    marginBottom: 12,
    textAlign: "center",
  },
  message: {
    fontSize: 16,
    textAlign: "center",
    marginBottom: 32,
    lineHeight: 24,
    paddingHorizontal: 20,
  },
});
